import { render, staticRenderFns } from "./challenges-detail.vue?vue&type=template&id=97ca547c&"
import script from "./challenges-detail.vue?vue&type=script&lang=js&"
export * from "./challenges-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports